/**
 * No-op observability provider
 * Used when observability is disabled or no provider configured
 */

import type { ObservabilityProvider } from "../types"

export const noopProvider: ObservabilityProvider = {
  init() {
    // No-op
  },

  captureException() {
    // No-op
  },

  captureMessage() {
    // No-op
  },

  setUser() {
    // No-op
  },

  setTag() {
    // No-op
  },

  setContext() {
    // No-op
  },

  setRelease() {
    // No-op
  },

  startSpan() {
    return { end: () => {} }
  },
}
